import SharePreviewContent from 'components/ShareDocument/SharePreviewContent';
import { extensionFromContentType } from 'components/UploadHub/fileTypeBadges';

export const withExtension = ({ fileName, contentType }: { fileName?: string; contentType?: string }) => {
  if (!fileName || /\.[^./]+$/.test(fileName)) return fileName;
  const ext = extensionFromContentType(contentType);
  return ext ? `${fileName}.${ext}` : fileName;
};

export interface SharedDocumentData {
  documentUrl?: string;
  fileName?: string;
  contentType?: string;
  backgroundColor?: string;
  organisationLogo?: string;
}

const SharedDocumentPreview = ({ document: sharedDocument }: { document: SharedDocumentData }) => {
  const fileNameWithExtension = withExtension({
    fileName: sharedDocument.fileName,
    contentType: sharedDocument.contentType,
  });

  return (
    <div style={{ backgroundColor: sharedDocument.backgroundColor, minHeight: '100vh' }}>
      <div className='share-document-page main-content-wrapper px-3 px-lg-5 py-5 mx-auto' style={{ maxWidth: '920px' }}>
        <div className='flex-centered mb-4 mb-lg-5'>
          <img
            src={`${sharedDocument.organisationLogo}`}
            alt='Organisation logo'
            style={{ width: '40px' }}
            className='rounded'
          />
          <p className='mb-0 pl-3  title-h4-bold'>{sharedDocument.fileName}</p>
        </div>
        <div className='share-document-preview  mx-auto'>
          <SharePreviewContent
            url={sharedDocument?.documentUrl ?? ''}
            filename={fileNameWithExtension}
            containedPreview
          />
        </div>
      </div>
    </div>
  );
};

export default SharedDocumentPreview;
